import { Column, ColumnCenter, Row } from "style/preset"
import { CardStyle2, CardStyle3, ImgBoxWrap, SvgComWrap } from "./DashboardCom"
import StyledContainer from "style/styledContainer"

import { ReactComponent as DaoWebSvg } from 'assets/svgs/dao_web.svg'
import { ReactComponent as DaoStakingSvg } from 'assets/svgs/dao_nav_staking.svg'
import { ReactComponent as DaoParticipateSvg } from 'assets/svgs/dao_nav_participate.svg'
import { ReactComponent as DaoTimeSvg } from 'assets/svgs/dao_time.svg'
import styled from "styled-components"
import SvgCom from "components/SvgCom"
import { AddNewBtnLabelWrap, AddNewBtnWrap, DaoStakingSvgWrap } from ".."
import useDao from "hooks/useDao"
import { formatNum } from "utils"
import { formatUnits } from "viem"
import moment from "moment"
import BigNumber from "bignumber.js"


interface Props {
    onOpenStakeWin?: () => void
}

const StakingCom = ({onOpenStakeWin}: Props) => {
    const { totalStaking, userVoting, totalStakedXCHNG, stakeList, totalVXCHNGStaked } = useDao()

    const formatAmount = (amount: string) => {
        return formatNum(formatUnits(BigInt(amount), 18), 2) 
    }

    const getDuration = (item: any) => {
        const vAmountBN = new BigNumber(item.vXCHNGAmount)
        const amountBN =  new BigNumber(item.amount)
        const rate  = vAmountBN.div(amountBN).toString()
        let result = {
            foramtStr: '',
            month: 0,
            days: 0,
            foramtDate: ''
        }
        if(rate === '1') {
            result = {
                foramtStr: '6 Months',
                month: 6,
                days: 180,
                foramtDate: ''
            }
        } else if(rate === '1.5') {
            result = {
                foramtStr: '1 Year',
                month: 12,
                days: 365,
                foramtDate: ''
            }
        } else if(rate === '3') {
            result = {
                foramtStr: '2 Years',
                month: 24,
                days: 730,
                foramtDate: ''
            }
        } else {
            result = {
                foramtStr: '4 Years',
                month: 48,
                days: 1460,
                foramtDate: ''
            }
        }
        const endTime = moment((+item.unlockTime) * 1000)
        const curTime = endTime.subtract(result.days, 'day')
        result['foramtDate'] = curTime.format('MMM D, YYYY - hh:mm A')
        return result
    }

    const getLeftUnstakeDays = (unlockTime: string) => {
        const curTime = moment()
        const endTime = moment((+unlockTime)*1000)    
        const days = endTime.diff(curTime, 'day')
        return days
    }

    return <div>
        <Row $justifyContent="space-between">
            <CardStyle3>
                <ImgBoxWrap $width="40px !important;" $height="40px !important;">
                    <SvgComWrap Svg={DaoStakingSvg} size="22.5"></SvgComWrap>
                </ImgBoxWrap>
                <Column $ml="20px">
                    <StyledContainer $fontSize="14px" $lineHeight="1" $roobertRegular>Total ecosystem staked balance</StyledContainer>
                    <Row $mt="8px">
                        <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(totalStaking, 2)} XCHNG</StyledContainer>
                    </Row>
                    <StyledContainer $mt="16px" $fontSize="14px" $lineHeight="1" $roobertRegular>Your total staked balance</StyledContainer>
                    <Row $mt="8px">
                        <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(totalStakedXCHNG, 2)} XCHNG</StyledContainer>
                    </Row>
                </Column>
            </CardStyle3>
            <StyledContainer $width="10px"></StyledContainer>
            <CardStyle3>
                <ImgBoxWrap $width="40px !important;" $height="40px !important;">
                    <SvgComWrap Svg={DaoParticipateSvg} size="22.5"></SvgComWrap>
                </ImgBoxWrap>
                <Column $ml="20px">
                    <StyledContainer $fontSize="14px" $lineHeight="1" $roobertRegular>Total ecosystem voting token balance</StyledContainer>
                    <Row $mt="8px">
                        <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(totalVXCHNGStaked, 2)} vXCHNG</StyledContainer>
                    </Row>
                    <StyledContainer $mt="16px" $fontSize="14px" $lineHeight="1" $roobertRegular>Your current voting token balance</StyledContainer>
                    <Row $mt="8px">
                        <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(userVoting, 2)} vXCHNG</StyledContainer>
                    </Row>
                </Column>
            </CardStyle3>
        </Row>
        {/* <Row $justifyContent="space-between">
            <CardStyle2>
                <ImgBoxWrap>
                    <SvgComWrap Svg={DaoWebSvg} size="18"></SvgComWrap>
                </ImgBoxWrap>
                <StyledContainer $mt="12px" $fontSize="14px" $lineHeight="1" $fontWeight4>Total ecosystem staked balance</StyledContainer>
                <Row $mt="8px">
                    <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(totalStaking, 2)} XCHNG</StyledContainer>
                </Row>
            </CardStyle2>
            <CardStyle2>
                <ImgBoxWrap>
                    <SvgComWrap Svg={DaoStakingSvg} size="18"></SvgComWrap>
                </ImgBoxWrap>
                <StyledContainer $mt="12px" $fontSize="14px" $lineHeight="1" $fontWeight4>Your total staked balance</StyledContainer>
                <Row $mt="8px">
                    <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(totalStakedXCHNG, 2)} XCHNG</StyledContainer>
                </Row>
            </CardStyle2>
            <CardStyle2>
                <ImgBoxWrap>
                    <SvgComWrap Svg={DaoParticipateSvg} size="18"></SvgComWrap>
                </ImgBoxWrap>
                <StyledContainer $mt="12px" $fontSize="14px" $lineHeight="1" $fontWeight4>Your current voting token balance</StyledContainer>
                <Row $mt="8px">
                    <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6 $mr="8px">{formatNum(userVoting, 2)} vXCHNG</StyledContainer>
                </Row>
            </CardStyle2>
        </Row> */}
        <StyledContainer $height="50px"></StyledContainer>
        <StyledContainer $fontSize="18px" $lineHeight="1" $fontWeight6>Your staking history</StyledContainer>
        <StyledContainer $height="20px"></StyledContainer>
        <TableHeaderWrap>
            <StyledContainer $flex1="2" $fontSize="14px" $fontWeight6 $lineHeight="1" $ml="20px">Amount staked</StyledContainer>
            <StyledContainer $flex1="2" $fontSize="14px" $fontWeight6 $lineHeight="1">Staking period</StyledContainer>
            <StyledContainer $flex1="1" $fontSize="14px" $fontWeight6 $lineHeight="1">Time left until unstaking</StyledContainer>
        </TableHeaderWrap>
        <StyledContainer $height="20px"></StyledContainer>
        {
            (!!stakeList.length) && stakeList.map((item: any, index) => <TableRowWrap key={index}>
                    <Column $ml="20px" $flex1="2">
                        <StyledContainer $fontSize="16px" $lineHeight="1" $fontWeight6>{formatAmount(item.amount)} XCHNG</StyledContainer>
                        <StyledContainer $fontSize="14px" $lineHeight="1" $fontWeight5 $mt="8px" $mb="12px">Received: +{formatAmount(item.vXCHNGAmount)} vXCHNG</StyledContainer>
                        <StyledContainer $fontSize="12px" $lineHeight="1" $fontWeight5 $color="#767A7F">Staked on {getDuration(item)['foramtDate']}</StyledContainer>
                    </Column>
                    <StyledContainer $flex1="2" $fontSize="14px" $fontWeight5 $lineHeight="1">{getDuration(item)['foramtStr']}</StyledContainer>
                    <Row $flex1="1">
                        {
                            getLeftUnstakeDays(item.unlockTime) > 0 && <>
                                <SvgCom Svg={DaoTimeSvg} size="18"></SvgCom>
                                <StyledContainer $fontSize="14px" $lineHeight="1" $fontWeight5 $ml="8px">{getLeftUnstakeDays(item.unlockTime)} Days</StyledContainer>
                            </>
                        }
                        {
                            getLeftUnstakeDays(item.unlockTime) <= 0 && <AddNewBtnWrap>
                                <AddNewBtnLabelWrap $ml="0 !important" $roobertSemiBold>Unstake</AddNewBtnLabelWrap>
                            </AddNewBtnWrap>
                        }
                    </Row>
                </TableRowWrap>
            )
        }
        {
            (!!!stakeList.length) && <ColumnCenter>
                <StyledContainer $height="65px"></StyledContainer>
                <StyledContainer $mb="20px" $fontSize="14px" $fontWeight5 $lineHeight="1">You haven’t staked yet</StyledContainer>
                <AddNewBtnWrap onClick={onOpenStakeWin}>
                    <DaoStakingSvgWrap></DaoStakingSvgWrap>
                    <AddNewBtnLabelWrap $roobertSemiBold>Stake now</AddNewBtnLabelWrap>
                </AddNewBtnWrap>
            </ColumnCenter>
        }
    </div>
}

const TableHeaderWrap = styled(Row)`
    border-radius: 9px;
    border: 1px solid #F2F2F2;
    box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);
    padding: 18px 0;
`


const TableRowWrap = styled(Row)`
    border-radius: 9px;
    background-color: #FAFAFA;
    margin-bottom: 5px;
    padding: 20px 0;
`

export default StakingCom